import { Component, OnInit, ViewChild } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { MessageService, MenuItem } from 'primeng/api';
import { ExcursionServiceService } from '../service/excursion-service.service';
import { DatePipe } from '@angular/common';
import { environment } from  '../../environments/environment';

@Component({
  selector: 'app-arr-dep-report',
  templateUrl: './arr-dep-report.component.html',
  styleUrls: ['./arr-dep-report.component.css'],
  providers: [MessageService]
})
export class ArrDepReportComponent implements OnInit {

  constructor(private httpClient: HttpClient,private excursionServiceService:ExcursionServiceService,
    private datePipe: DatePipe) { }

  Title:string = "Arrival Report";
  DateLabel:string = "Date of Arrival";
  arrdepForm = new FormGroup({
    Type: new FormControl('', Validators.required),
    dateofArrDep: new FormControl(new Date(), [Validators.required, Validators.minLength(3)]),
    CountryGroup:new FormControl('',Validators.required),
    Country:new FormControl('',Validators.required),
    Airport:new FormControl('',Validators.required),
    Agent:new FormControl('',Validators.required),
    Hotel:new FormControl('',Validators.required),
    HotelCity:new FormControl('',Validators.required),
    Flight:new FormControl('',Validators.required),
    GroupBy:new FormControl('',Validators.required),
    FlightOrShift:new FormControl('',Validators.required),
    Division:new FormControl('',Validators.required),
    OnlyFlight:new FormControl(false,Validators.required),
    OnlyShifting:new FormControl(false,Validators.required)
  });

  CountryGroupList:any = [];
  selectedCountryGroup:any;
  filteredCountryGroup:any;

  CountryList:any = [];
  selectedCountry:any;
  filteredCountry:any;

  AgentList:any = [];
  selectedAgent:any;
  filteredAgent:any;

  HotelsList:any = [];
  selectedHotel:any;
  filteredHotel:any;

  HotelCityList:any = [];
  selectedHotelCity:any;
  filteredHotelCity:any;

  FlightList:any = [];
  selectedFlight:any;
  filteredFlight:any;

  DivisionList:any = [];
  selectedDivision:any;
  filteredDivision:any;

  AirportList:any = [];
  selectedAirport:any;
  filteredAirport:any;

  arrdepList:any = [];
  ArrivalDepartureList:any = [];
  loading:boolean = false;
  arrdepPageIndex: number = 0;

  selectedType:number = 0;

  TypeList = [
    {'id': 0, 'value': 'Arrival'},
    {'id': 1, 'value': 'Departure'}
  ]

  GroupByList = [
    {'id':0, 'value':'FlightNumber'},
    {'id':1, 'value':'ReservationNumber'},
    {'id':2, 'value':'Hotel'},
    {'id':3, 'value':'Agent'},
    {'id':4, 'value':'FlightTime'},
    {'id':5, 'value':'Country'},
  ]

  ngOnInit(): void {
    this.getMasterData();
    this.arrdepForm.patchValue({
      Type: 0,
      GroupBy: 0
    });
  }

  getMasterData(){
    this.excursionServiceService.getarrdepreportmaster().subscribe(res=>{
      if(res['result'] == 1){
        this.CountryGroupList = res['data'][0]['CountryGroup'];
        this.CountryList = res['data'][0]['Country'];
        this.AgentList = res['data'][0]['Agent'];
        this.HotelsList = res['data'][0]['Hotels'];
        this.HotelCityList = res['data'][0]['HotelCity'];
        this.FlightList = res['data'][0]['Flight'];
        this.DivisionList = res['data'][0]['Division'];
        this.AirportList = res['data'][0]['Airport'];
      }
    });
  }

  typeChange(event: any){
    console.log(event);
    this.selectedType = event;
    this.ArrivalDepartureList = [];
    if(event == 0){
      this.Title = "Arrival Report";
      this.DateLabel = "Date of Arrival";
    }
    else if(event == 1){
      this.Title = "Departure Report";
      this.DateLabel = "Date of Departure";
    }
  }

  filterCountryGroup(event:any) { 
    let filtered: any[] = []; 
    let query = event.query; 
    for (let i = 0; i < this.CountryGroupList.length; i++) { 
        let cg = this.CountryGroupList[i]; 
        if (cg.countrygroupname.toLowerCase().indexOf(query.toLowerCase()) == 0 || query.trim() == '') { 
            filtered.push(cg); 
        }
    }

    this.filteredCountryGroup = filtered;
  }

  filterCountry(event:any){
    let filtered: any[] = []; 
    let query = event.query; 
    for (let i = 0; i < this.CountryList.length; i++) { 
        let cg = this.CountryList[i]; 
        if (cg.ctryname.toLowerCase().indexOf(query.toLowerCase()) == 0 || query.trim() == '') { 
            filtered.push(cg); 
        }
    }

    this.filteredCountry = filtered;
  }

  filterAgent(event:any){
    let filtered: any[] = []; 
    let query = event.query; 
    for (let i = 0; i < this.AgentList.length; i++) { 
        let cg = this.AgentList[i]; 
        if (cg.agentname.toLowerCase().indexOf(query.toLowerCase()) == 0 || query.trim() == '') { 
            filtered.push(cg); 
        }
    }

    this.filteredAgent = filtered;
  }

  filterHotel(event:any){
    let filtered: any[] = []; 
    let query = event.query; 
    for (let i = 0; i < this.HotelsList.length; i++) { 
        let cg = this.HotelsList[i]; 
        if (cg.partyname.toLowerCase().indexOf(query.toLowerCase()) == 0 || query.trim() == '') { 
            filtered.push(cg); 
        }
    }

    this.filteredHotel = filtered;
  }

  filterHotelCity(event:any){
    let filtered: any[] = []; 
    let query = event.query; 
    for (let i = 0; i < this.HotelCityList.length; i++) { 
        let cg = this.HotelCityList[i]; 
        if (cg.cityname.toLowerCase().indexOf(query.toLowerCase()) == 0 || query.trim() == '') { 
            filtered.push(cg); 
        }
    }

    this.filteredHotelCity = filtered;
  }

  filterFlight(event:any){
    let filtered: any[] = []; 
    let query = event.query; 
    for (let i = 0; i < this.FlightList.length; i++) { 
        let cg = this.FlightList[i]; 
        if (cg.flightcode.toLowerCase().indexOf(query.toLowerCase()) == 0 || query.trim() == '') { 
            filtered.push(cg); 
        }
    }

    this.filteredFlight = filtered;
  }

  filterAirport(event:any){
    let filtered: any[] = []; 
    let query = event.query; 
    for (let i = 0; i < this.AirportList.length; i++) { 
        let cg = this.AirportList[i]; 
        if (cg.airportbordername.toLowerCase().indexOf(query.toLowerCase()) == 0 || query.trim() == '') { 
            filtered.push(cg); 
        }
    }

    this.filteredAirport = filtered;
  }

  filterDivision(event:any){
    let filtered: any[] = []; 
    let query = event.query; 
    for (let i = 0; i < this.DivisionList.length; i++) { 
        let cg = this.DivisionList[i]; 
        if (cg.division_master_des.toLowerCase().indexOf(query.toLowerCase()) == 0 || query.trim() == '') { 
            filtered.push(cg); 
        }
    }

    this.filteredDivision = filtered;
  }

  Arrival_Departure_Report_Search(val: boolean){
    this.loading = true;
    console.log(this.arrdepForm.value);
    if(this.arrdepForm.value['dateofArrDep'] != '' && this.arrdepForm.value['dateofArrDep'] != null){
      this.arrdepForm.value['dateofArrDep'] = new Date(this.arrdepForm.value['dateofArrDep'])
      this.arrdepForm.value['dateofArrDep'] = new Date(this.arrdepForm.value['dateofArrDep'].getTime() - this.arrdepForm.value['dateofArrDep'].getTimezoneOffset()*60000).toISOString();
    }

    let CountryOrAirport = "";
    if(this.selectedType == 0){
      CountryOrAirport = this.arrdepForm.value.Country.ctrycode;
    }
    else if(this.selectedType == 1){
      CountryOrAirport = this.arrdepForm.value.Airport.airportbordercode; 
    }

    let va = {
      "Type": this.selectedType,
      "dateofarrivalordeparture": this.arrdepForm.value.dateofArrDep,
      "agent": this.arrdepForm.value.Agent.agentcode,
      "countrygroup": this.arrdepForm.value.CountryGroup.countrygroupcode,
      "countryorairport" : CountryOrAirport,
      "city": this.arrdepForm.value.HotelCity.citycode,
      "party": this.arrdepForm.value.Hotel.partycode,
      "flightcode": this.arrdepForm.value.Flight.flightcode,
      "groupby": this.arrdepForm.value.GroupBy,
      "flightonly": this.arrdepForm.value.OnlyFlight == true? 1 : 0,
      "shiftonly": this.arrdepForm.value.OnlyShifting == true? 1 : 0,
      "divcode": this.arrdepForm.value.Division.division_master_code
    }

    this.excursionServiceService.getArrivalDepartureReport(va).subscribe(res=>{
      this.loading = false;
      if(res['result'] == 1){
        this.ArrivalDepartureList = res['data'];
      }
      else{

      }
    });

    //console.log(va);
  }

  arrivalDepartureExcelExport(){
    let date;
    if(this.arrdepForm.value['dateofArrDep'] != '' && this.arrdepForm.value['dateofArrDep'] != null){
      this.arrdepForm.value['dateofArrDep'] = new Date(this.arrdepForm.value['dateofArrDep'])
      this.arrdepForm.value['dateofArrDep'] = new Date(this.arrdepForm.value['dateofArrDep'].getTime() - this.arrdepForm.value['dateofArrDep'].getTimezoneOffset()*60000).toISOString();
      date = this.datePipe.transform(this.arrdepForm.value.dateofArrDep, 'dd-MM-yyyy');
    }
    let data = []
    const currentDate = new Date();
    const formattedDate = this.datePipe.transform(currentDate, 'ddMMyyyyHHmmss');
    let fileName = "";
    if(this.selectedType == 0){
      fileName = 'Arrival_Report_'+ formattedDate + '.xlsx';
    }
    else if(this.selectedType == 1){
      fileName = 'Departure_Report_'+ formattedDate + '.xlsx';
    }
    data = this.ArrivalDepartureList;
    let va = {
      "date": date,
      "Type": this.selectedType,
      "data": data
    }

    this.excursionServiceService.export_ArrivalDepartureReport(va).subscribe((blob: Blob) => {
      // Create a blob URL for the Blob object
      const url = window.URL.createObjectURL(blob);

      // Create a link element and set its attributes
      const link = document.createElement('a');
      link.href = url;
      link.download = fileName;

      // Trigger the download by simulating a click on the link
      link.click();

      // Clean up by revoking the blob URL
      window.URL.revokeObjectURL(url);
    },
    error => {
      // Handle error
      console.error('Error downloading file:', error);
    });

  }

  onArrDepPageChange(event: any) {
    this.arrdepPageIndex = ((event.first / event.rows) + 1);
    this.arrdepPageIndex = (this.arrdepPageIndex * event.rows) - 10;
  }

}
